<template>
  <v-container id="taxslab-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">{{$i18n.t("Invoice Setup") }}</div>
          </template>

          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    :items="sequence"
                    item-text="name"
                    item-value="value"
                    v-model="taxslab.seqLength"
                    :label="$i18n.t('Sequence Length')"
                    type="number"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-card>
                    <v-list-item-content calss="px-3">
                      <v-row>
                        <v-col cols="12" md="4" class="mx-3">
                          <h3>{{ $i18n.t("Prefixes") }}</h3>
                        </v-col>
                        <v-spacer />
                        <v-col clos="12" md="6">
                          <v-btn
                            @click="taxslab.prefixes = newItem(taxslab.prefixes)"
                            small
                            style="width:60px;float:right;"
                            color="light-blue"
                            text
                          >
                            <v-icon>mdi-plus</v-icon>
                            <h3>{{ $i18n.t("Add") }}</h3>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-simple-table dense style="padding: 10px">
                      <tbody>
                        <tr v-for="(item, index) in taxslab.prefixes" :key="'item' + index">
                          <td>
                            <v-select
                              v-model="item.kind"
                              :label="$i18n.t('Kind')"
                              :disabled="!item.addedNow"
                              :items="statusList"
                              item-text="name"
                              item-value="value"
                              clearable
                            />
                          </td>
                          <td>
                            <v-text-field
                              v-model="item.invoicePrefix"
                              :label="$i18n.t('Prefix')"
                              :disabled="!item.addedNow"
                            />
                          </td>
                          <td>
                            <z-date-picker
                              v-model="item.from"
                              :label="$i18n.t('Valid From')"
                              :disabled="!item.addedNow"
                            />
                          </td>
                          <td>
                            <z-date-picker
                              v-model="item.till"
                              :label="$i18n.t('Valid Till')"
                              :disabled="!item.addedNow"
                            />
                          </td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="remove(taxslab.prefixes, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <v-spacer></v-spacer>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  taxslab = { prefixes: [] };
  id = null;
  statusList = [
    { value: 1, name: "Genral" },
    { value: 2, name: "SEZ" },
  ];
  sequence = [
    { value: 0, name: "Auto" },
    { value: 3, name: "3" },
    { value: 4, name: "4" },
    { value: 5, name: "5" },
    { value: 6, name: "6" },
    { value: 7, name: "7" },
    { value: 8, name: "8" },
    { value: 9, name: "9" },
    { value: 10, name: "10" },
  ];

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      const response = await doPost("/api/invoicesetup/save", this.taxslab);
      // if (!this.id) this.$router.push("/invoicesetup/" + response._id);
      this.get(response._id);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      const response = await doGet("/api/invoicesetup/detail");
      if (!response.prefixes) response.prefixes = [];
      this.taxslab = response;
      this.id = this.taxslab._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  mounted() {
    this.get(this.$route.params.id);
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({ addedNow: true });
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
